/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_CtaInputs */

const en_mk_how_cta = /** @type {(inputs: Mk_How_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the full tutorial`)
};

const id_mk_how_cta = /** @type {(inputs: Mk_How_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca tutorial lengkapnya`)
};

/**
* | output |
* | --- |
* | "Read the full tutorial" |
*
* @param {Mk_How_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_cta = /** @type {((inputs?: Mk_How_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_cta(inputs)
	return en_mk_how_cta(inputs)
});